<template>
  <div class="status-chips">
    <button
      v-if="sms"
      type="button"
      class="chip sms"
      :title="smsTitle"
      @click="$emit('open-sms')"
    >
      <span class="chip-k">短信</span>
      <b>{{ sms.verification_code || '新消息' }}</b>
      <span class="chip-x" @click.stop="$emit('dismiss-sms')">×</span>
    </button>
    <button
      v-if="cookieVisible && cookieCount > 0"
      type="button"
      class="chip cookie"
      :title="cookiePreview"
      @click="$emit('fix-login')"
    >
      <span class="chip-k">登录</span>
      <b>{{ cookieCount }}</b>
      <span class="chip-x" @click.stop="$emit('dismiss-cookie')">×</span>
    </button>
  </div>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'StatusChips',
  props: {
    sms: { type: Object, default: null },
    cookieCount: { type: Number, default: 0 },
    cookieVisible: { type: Boolean, default: false },
    cookiePreview: { type: String, default: '' },
  },
  emits: ['open-sms', 'dismiss-sms', 'fix-login', 'dismiss-cookie'],
  setup(props) {
    const smsTitle = computed(() => {
      const s = props.sms
      if (!s) return ''
      return `本机 ${s.local_identity || s.device_phone || '未识别'} · 来电 ${s.sender_phone || '未知'}`
    })
    return { smsTitle }
  },
}
</script>

<style scoped>
.status-chips {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 0 8px 0 10px;
  cursor: pointer;
  font-family: inherit;
  font-size: 12px;
  font-weight: 650;
}
.chip b {
  font-size: 13px;
  letter-spacing: 0.4px;
}
.chip-k {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.4px;
  opacity: 0.72;
}
.chip-x {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  font-size: 13px;
  line-height: 1;
  opacity: 0.55;
}
.chip-x:hover { opacity: 1; }
.chip.sms {
  background: #fff7e6;
  border-color: #f3d19e;
  color: #8a5a00;
}
.chip.sms b { color: #d48806; }
.chip.cookie {
  background: #fff7ed;
  border-color: #ffd8a8;
  color: #9c4221;
}

@media (max-width: 768px) {
  .status-chips {
    gap: 4px;
  }
  .chip {
    height: 28px;
    padding: 0 6px 0 8px;
    font-size: 11px;
  }
  .chip-k {
    display: none;
  }
  .chip b {
    font-size: 12px;
  }
}
</style>
